const playButton = document.querySelector('.why-hurom__visual--play')
const video = document.querySelector('.why-hurom__visual--video video')
const pauseButton = document.querySelector('.why-hurom__visual--pause')
const thumbnail = document.querySelectorAll('.why-hurom__visual--thumbnail')
const title = document.querySelector('.why-hurom__visual--title')

function onWhyHuromVideoPlay() {
	playButton.addEventListener('click', () => {
		video.play()
		playButton.classList.add('hidden')
		pauseButton.classList.remove('hidden')
		title.classList.add('hidden')
		thumbnail.forEach((item) => {
			item.classList.add('hide')
		})
	})
}

function onWhyHuromVideoPause() {
	if (!video.paused) return // 재생 중이면 리턴
	pauseButton.addEventListener('click', () => {
		video.pause()
		pauseButton.classList.add('hidden')
		playButton.classList.remove('hidden')
		title.classList.remove('hidden')
	})
}
onWhyHuromVideoPause()
onWhyHuromVideoPlay()

// const scrollUI = document.querySelector('.why-hurom__visual--scroll')

// function visibleScrollUI() {
// 	setTimeout(() => {
// 		scrollUI.classList.add('visible')
// 	}, 1000)
// }

// function hiddenScrollUI() {
// 	window.addEventListener('scroll', (event) => {
// 		const scrollTop = window.scrollY
// 		if (scrollTop > 150) {
// 			scrollUI.classList.remove('visible')
// 		} else {
// 			scrollUI.classList.add('visible')
// 		}
// 	})
// }

// visibleScrollUI()
// hiddenScrollUI()
